import * as React from "react";
import { forwardRef } from "react";
const SvgFinancialReport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M24.9999 19.0146H22.2892C21.4324 19.0152 20.6963 19.6232 20.5337 20.4644C20.3711 21.3057 20.8277 22.1441 21.6226 22.464L24.3746 23.5653C25.1695 23.8851 25.6261 24.7236 25.4635 25.5649C25.3009 26.4061 24.5647 27.0141 23.7079 27.0146H20.9999",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M23 28.0146V27.0146",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M23 19.0146V18.0146",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M23 31.0146C27.4183 31.0146 31 27.4329 31 23.0146C31 18.5964 27.4183 15.0146 23 15.0146C18.5817 15.0146 15 18.5964 15 23.0146C15 27.4329 18.5817 31.0146 23 31.0146Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7 14.0146H14",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7 19.0146H11",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M7 24.0146H11",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13 31.0146H3C1.89543 31.0146 1 30.1192 1 29.0146V8.01465C1 6.91008 1.89543 6.01465 3 6.01465H8C8 3.25322 10.2386 1.01465 13 1.01465C15.7614 1.01465 18 3.25322 18 6.01465H23C24.1046 6.01465 25 6.91008 25 8.01465V11.0146",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M13 5.01465C13.2761 5.01465 13.5 5.23851 13.5 5.51465C13.5 5.79079 13.2761 6.01465 13 6.01465C12.7239 6.01465 12.5 5.79079 12.5 5.51465C12.5 5.23851 12.7239 5.01465 13 5.01465",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgFinancialReport);
export default ForwardRef;
